import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Navbar } from 'react-bootstrap';
import Switch from 'rc-switch';

import NavbarCurrentUser from './navbar-current-user.js';
import NavbarLoginForm from './navbar-login-form';
import ModalConfirm from '../modals/modal-confirm';

import { signIn, signOut, impersonate } from '../../../actions/auth-user';

class NavbarUserBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unimpersonate: false
    };

    this.handleSignIn = this.handleSignIn.bind(this);
    this.handleSignOut = this.handleSignOut.bind(this);
    this.handleUnimpersonate = this.handleUnimpersonate.bind(this);
    this.renderUnimpersonateButton = this.renderUnimpersonateButton.bind(this);
    this.toggleUnimpersonateDialog = this.toggleUnimpersonateDialog.bind(this);
    this.renderUnimpersonateConfirmation = this.renderUnimpersonateConfirmation.bind(this);
  }

  handleSignIn(data) {
    this.props.signIn(data.email, data.password, true);
  }

  handleSignOut(e) {
    this.props.signOut();
  }

  handleUnimpersonate() {
    const { authUser } = this.props;

    this.setState(
      { unimpersonate: false },
      this.props.impersonate.bind(this, authUser.get('actualUserId'))
    );
  }

  toggleUnimpersonateDialog() {
    this.setState({
      unimpersonate: !this.state.unimpersonate
    });
  }

  renderUnimpersonateButton() {
    const { authUser } = this.props;

    if (authUser.get('userId') === authUser.get('actualUserId')) {
      return null;
    }

    return (
      <div>
        <Navbar.Form pullRight className="navbar-form_switcher">
          <Switch 
            checkedChildren={'On'}
            unCheckedChildren={'Off'}
            checked={true}
            disabled={false}
            onChange={this.toggleUnimpersonateDialog} 
          />
          <span className="switcher-label switcher-label_navbar">Impersonated as</span>
        </Navbar.Form>

        {this.renderUnimpersonateConfirmation()}
      </div>
    );
  }

  renderUnimpersonateConfirmation() {
    return (
      <ModalConfirm
        isVisible={this.state.unimpersonate}
        onClose={this.toggleUnimpersonateDialog}
        onSubmit={this.handleUnimpersonate}
        title="Switch off Impersonate Mode"
        body="Please confirm that you want to switch off impersonate mode and return to administration area."
        submitButtonText="Confirm"
        styles="primary"
      />
    );
  }

  render() {
    const { authUser, pathname } = this.props;

    if (authUser.get('userId')) {
      return (
        <div className="header__current-user-wrapper">
          <NavbarCurrentUser user={authUser} onSignOut={this.handleSignOut} />

          {this.renderUnimpersonateButton()}
        </div>
      );
    }

    return (
      <NavbarLoginForm
        pathname={pathname}
        isUserLoading={authUser.get('isLoading')}
        destroyOnUnmount={false}
        onSubmit={this.handleSignIn}
      />
    );
  }
}

export default connect(state => ({ authUser: state.authUser }), {
  signIn,
  signOut,
  impersonate
})(NavbarUserBlock);



// WEBPACK FOOTER //
// ./src/components/common/navbar/navbar-user-block.js